'use client';
import { parse, isBefore } from 'date-fns';
import { tz } from '@date-fns/tz';

/**
 * Checks if the current moment (converted to the given `timeZone`) is before the cutoff time.
 *
 * @param cutoff   Date & time string in the format `YYYY-MM-DD HH:mm:ss` **in the same `timeZone`**.
 *                 Example: `'2025-07-16 15:00:00'`.
 * @param timeZone IANA time-zone string, e.g. `'Asia/Singapore'`, `'America/New_York'`.
 * @param pattern  Optional custom date-fns parse pattern. Defaults to `'yyyy-MM-dd HH:mm:ss'`.
 */
export const isBeforeNowInTimeZone = (cutoff: string, timeZone: string, pattern = 'yyyy-MM-dd HH:mm:ss'): boolean => {
  // Parse cutoff string in the specified time-zone context. The resulting Date
  // represents the exact moment of the cutoff in UTC internally.
  const cutoffDate = parse(cutoff, pattern, new Date(), { in: tz(timeZone) });

  // Simply compare instants (UTC timestamps). No extra `in` option needed: both
  // `new Date()` (current instant) and `cutoffDate` are absolute moments.
  return isBefore(new Date(), cutoffDate);
};
